// extracted by mini-css-extract-plugin
export var closeButton = "_p0-2";
export var closeButtonIcon = "_p0-3";
export var lightboxContent = "_p0-1";
export var lightboxOverlay = "_p0-0";